import { ColorX } from "IZOX/STATIC";

class QFileStatusUtils {

  // "uploading" | "pending" | "processing" | "completed" | "failed"
  static Status = [
    {
      cap: {
        EN: "Uploading",
        TC: "上傳中"
      },
      val: "uploading",
      color: ColorX.CSS("pureWhite"),
      bgColor: ColorX.CSS("cmBlue")
    },
    {
      cap: {
        EN: "Pending",
        TC: "待處理"
      },
      val: "pending",
      color: ColorX.CSS("pureWhite"),
      bgColor: ColorX.CSS("cmBlue")
    },
    {
      cap: {
        EN: "Processing",
        TC: "處理中"
      },
      val: "processing",
      color: ColorX.CSS("pureWhite"),
      bgColor: ColorX.CSS("cmBlue")
    },
    {
      cap: {
        EN: "Completed",
        TC: "已完成"
      },
      val: "completed",
      color: ColorX.CSS("pureWhite"),
      bgColor: ColorX.CSS("green")
    },
    {
      cap: {
        EN: "Failed",
        TC: "失敗"
      },
      val: "failed",
      color: ColorX.CSS("pureWhite"),
      bgColor: ColorX.CSS("red")
    }
  ]

}

export default QFileStatusUtils;